import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Oval } from 'react-loader-spinner';
import style from './NewsLetter.module.css';

const NewsLetter = () => {
  const [loading, setLoading] = useState(true);
  const [newsLetter, setNewsLetter] = useState([]);
  useEffect(() => {
    const allNewsletter = async () => {
      await axios
        .get('/newsletter', {
          headers: { 'Access-Control-Allow-Origin': '*' },
          withCredentials: true,
        })
        .then((res) => {
          setLoading(false);
          setNewsLetter(res.data.newsLetter);
        })
        .catch(() => {
          setLoading(false);
        });
    };
    allNewsletter();
  }, []);

  return (
    <div>
      {!loading ? (
        newsLetter.length != 0 ? (
          <div>
            <div className={style.TableHead}>
              <div>S. No.</div>
              <div>Email ID</div>
            </div>
            <div>
              {newsLetter.map((p, i) => {
                return (
                  <div className={style.TableData} key={p._id}>
                    <div>{i + 1}</div>
                    <div>{p.email}</div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className={style.Center} style={{ fontWeight: '500' }}>
            No User found!
          </div>
        )
      ) : (
        <div className={style.Center}>
          <Oval
            ariaLabel='loading-indicator'
            height={80}
            width={80}
            strokeWidth={5}
            color='white'
            secondaryColor='purple'
          />
        </div>
      )}
    </div>
  );
};

export default NewsLetter;
